import { Link } from "react-router-dom";
import { Trash2 } from "lucide-react";
import type { Draft } from "../lib/api";

interface DraftCardProps {
  draft: Draft;
  onDelete?: (id: string) => void;
}

export const DraftCard = ({ draft, onDelete }: DraftCardProps) => {
  const preview = draft.content.slice(0, 180);
  const truncated = draft.content.length > 180;
  return (
    <article
      data-testid={`draft-card-${draft.id}`}
      className="rounded-xl border border-slate-200 dark:border-zinc-800 bg-white dark:bg-zinc-900 transition hover:border-slate-400 dark:hover:border-zinc-600"
    >
      <Link to={`/drafts/${draft.id}`} className="block p-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-zinc-400">
            {draft.format} · {draft.theme}
          </span>
          <span className="text-xs text-slate-400 dark:text-zinc-500">
            {new Date(draft.createdAt).toLocaleString("pt-BR", {
              dateStyle: "short",
              timeStyle: "short",
            })}
          </span>
        </div>
        <p className="text-sm text-slate-900 dark:text-zinc-100 whitespace-pre-wrap break-words leading-relaxed">
          {preview}
          {truncated && <span className="text-slate-400 dark:text-zinc-500">...</span>}
        </p>
        {draft.hashtags.length > 0 && (
          <div className="mt-2 flex gap-2 flex-wrap">
            {draft.hashtags.slice(0, 3).map((h) => (
              <span key={h} className="text-xs text-[#0a66c2] dark:text-[#5fa8ed]">
                {h}
              </span>
            ))}
          </div>
        )}
      </Link>
      {onDelete && (
        <div className="px-4 pb-3 -mt-1 flex items-center justify-start border-t border-slate-100 dark:border-zinc-800 pt-2">
          <button
            type="button"
            onClick={() => onDelete(draft.id)}
            aria-label="Deletar draft"
            title="Deletar draft"
            data-testid={`draft-delete-${draft.id}`}
            className="text-slate-400 dark:text-zinc-500 hover:text-red-600 dark:hover:text-red-400 transition p-1.5 rounded -ml-1.5"
          >
            <Trash2 size={16} aria-hidden />
          </button>
        </div>
      )}
    </article>
  );
};
